import { StoreTypes } from '../../src/util/types';

export const changeType = (state = { changeType: [] }, action) => {
    switch (action.type) {
        case StoreTypes.SAVE_CHANGE_TYPE:
            return { ...state, changeType: action.payload }
        default:
            return state;
    }
}